module.exports = __webpack_public_path__ + "img/oculus_hifi_4.9cc7f62b.png";